import { USER_AUTH_KEY } from "../../utils/constants";
import { mergeArrayOfObjects } from "../../utils/mergeArrayOfObjects";

export default async (user) => {
  console.log("Inside fetchMsEmailUser ", user);

  const baseApiUri = process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN;
  let userClients = [];
  const orgIds = [];
  let readOnlyClients = [];
  let userRolesResults = [];
  const userMsidRoles = user.role || JSON.parse(user.roles || "[]"); //["AZU_EIMP_UI_HIE_ALL_DS_TEST"]; //["AZU_EIMP_UI_HIE_ORGADMIN_TEST"];
  let role = "Read-Only";
  let deRole = "";

  // Validate roles
  const validRoles = userMsidRoles.filter(
    (role) => typeof role === "string" && role.includes("AZU_EIMP_UI_"),
  );

  if (validRoles.length === 0) {
    console.log("❌ User has no valid application roles");
    throw new Error("User Not Found"); // Throw error for invalid users
  }

  for (const msidRole of userMsidRoles) {
    if (msidRole.includes("_DS_")) {
      role = "Data Steward";
      break;
    }
  }

  if (userMsidRoles.some((role) => role.includes("_DE_"))) {
    deRole = "Data Engineer";
  } else {
    deRole = role;
  }

  const getClientsByOrg = async (msidRole) => {
    const baseApiUri = process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN;
    const orgResponse = await fetch(
      `${baseApiUri}/organizations/?short_code=${msidRole.split("_")[3]}`,
    );
    const orgData = await orgResponse.json();
    if (orgData.results && orgData.results.length === 1) {
      const orgId = orgData.results[0].id;
      console.log("orgData.id ", orgId);
      orgIds.push(orgId);
      const clients = await fetch(
        `${baseApiUri}/rpc/clients/?organization__id=${orgId}`,
      );
      const clientsData = await clients.json();
      userClients = mergeArrayOfObjects(userClients, clientsData.results, "id");
      console.log("userClients ", userClients);
    }
    return userClients;
  };

  const getClientByRole = async (msidRole) => {
    const roleArray = msidRole.split("_");
    const prefixRole =
      roleArray[0] +
      "_" +
      roleArray[1] +
      "_" +
      roleArray[2] +
      "_" +
      roleArray[3] +
      "_";
    const orgAdminRole = prefixRole + "ORGADMIN" + "_" + roleArray[5];
    const allRole =
      prefixRole + "ALL" + "_" + roleArray[5] + "_" + roleArray[6];
    if (
      !userMsidRoles.includes(orgAdminRole) &&
      !userMsidRoles.includes(allRole)
    ) {
      const clients = await fetch(
        `${baseApiUri}/rpc/clients/?organization__short_code=${roleArray[3]}&short_code=${roleArray[4]}`,
      );
      const clientsData = await clients.json();
      userClients = mergeArrayOfObjects(userClients, clientsData.results, "id");
      console.log("userClients ", userClients);
    }
  };

  if (userMsidRoles.join().includes("AZU_EIMP_UI_GLOBALADMIN")) {
    // Global admin should only be associated with Global Org and Account
    // but have access to all the orgs and accounts. This will fetch all the
    // orgs and associate them to the global user.
    //AZU_EIMP_UI_GLOBALADMIN_<ENV>

    const responseClients = await fetch(`${baseApiUri}/rpc/clients/`);
    const clientsData = await responseClients.json();
    userClients = clientsData.results;

    role = "Global Admin";
  } else {
    console.log("User is not a global admin");
    for (const msidRole of userMsidRoles) {
      console.log("msidRole ", msidRole);
      if (msidRole.includes("ORGADMIN")) {
        //AZU_EIMP_UI_<ORGCODE>_ORGADMIN_<ENV>
        console.log("Inside orgadmin");
        await getClientsByOrg(msidRole);
        role = "Organization Admin";
      } else if (msidRole.includes("ALL_DS")) {
        //AZU_EIMP_UI_<ORGCODE>_ALL_DS_<ENV>
        console.log("Inside all ds");
        if (!userMsidRoles.includes(msidRole.replace("ALL_DS", "ORGADMIN"))) {
          await getClientsByOrg(msidRole);
        }
      } else if (msidRole.includes("_DS_")) {
        //AZU_EIMP_UI_<ORGCODE>_<CLIENTCODE>_DS_<ENV>
        const clientCode = msidRole.split("_")[4];
        //Checking higher order role
        if (
          !userMsidRoles.includes(
            msidRole.replace(clientCode + "_DS", "ORGADMIN"),
          )
        ) {
          await getClientByRole(msidRole);
        }
      } else if (msidRole.includes("ALL_READONLY")) {
        //AZU_EIMP_UI_<ORGCODE>_ALL_READONLY_<ENV>
        console.log("Inside all read only");
        if (
          !userMsidRoles.includes(msidRole.replace("ALL_READONLY", "ORGADMIN"))
        ) {
          await getClientsByOrg(msidRole);
          for (const client of userClients) {
            readOnlyClients.push(client.name);
          }
        }
      } else if (msidRole.includes("_READONLY_")) {
        //AZU_EIMP_UI_<ORGCODE>_<CLIENTCODE>_READONLY_<ENV>
        //Checking higher order role
        const clientCode = msidRole.split("_")[4];
        if (
          !userMsidRoles.includes(msidRole.replace("_READONLY_", "_DS_")) &&
          !userMsidRoles.includes(
            msidRole.replace(clientCode + "_READONLY", "ORGADMIN"),
          )
        ) {
          await getClientByRole(msidRole);
          for (const client of userClients) {
            readOnlyClients.push(client.name);
          }
        }
      }
    }
  }

  // This value should come along with other saved preferences
  // from the fetch user call; for now using localStorage
  const sessionUser = window.localStorage.getItem(USER_AUTH_KEY)
    ? JSON.parse(window.localStorage.getItem(USER_AUTH_KEY))
    : null;
  const sessionClientId =
    sessionUser &&
    sessionUser.preferences &&
    sessionUser.preferences.selectedClient &&
    sessionUser.preferences.selectedClient.id
      ? sessionUser.preferences.selectedClient.id
      : null;
  // Verify that the user still has access to the saved client
  // or default to the only client available
  const sessionClient =
    userClients.length > 1
      ? userClients.find((client) => `${client.id}` === sessionClientId)
      : userClients[0];
  const selectedClient =
    sessionClientId && sessionClient ? sessionClient : null;

  userClients.sort((clientA, clientB) =>
    clientA.name.toLowerCase() <= clientB.name.toLowerCase() ? -1 : 1,
  );

  return {
    id: user.user_id,
    username: user.email,
    firstName: user.first_name,
    lastName: user.last_name,
    country_code: user.country_code,
    orgIds, //if user is org admin, orgIds will have list of ids for which user has admin access, otherwise it will be empty
    clients: userClients,
    readOnlyClients: readOnlyClients,
    preferences: {
      timeZone: "America/Chicago",
      selectedClient,
    },
    role,
    deRole,
    logoutUrl: user.logout_url,
  };
};
